import { NavbarBrand, Container, Navbar } from "react-bootstrap";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { Link } from "react-router-dom";

export default function PreCertLinkBanner() {

    return (
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3">
                <Container>
                    <NavbarBrand as={Link} to="/">preCERT®</NavbarBrand>
                    <NavbarToggle><span className="navbar-toggler-icon"></span></NavbarToggle>
                </Container>
            </Navbar>
    );
}
